// extracted by mini-css-extract-plugin
export var dropdownIcon = "_p0-6";
export var imgContainer = "_p0-3";
export var menuIcon = "_p0-5";
export var pillWrapper = "_p0-2";
export var pillsContainer = "_p0-1";
export var subscriptionCard = "_p0-0";
export var subscriptionLogo = "_p0-4";